export const contacts = [
    'ngkwanho120@gmail.com'
];

export const copyRight = 'Copyright © AdorableCatDev 2025';